import React from 'react';
import { SlideContent } from '../components/canvas/SlideContent';
import { SlideFooter } from '../components/canvas/SlideFooter';
import { SlideLogo } from '../components/canvas/SlideLogo';
import { NudgeableGroup } from '../components/canvas/NudgeableGroup';

/**
 * Centered Stack layout — zen/calm style.
 * Everything centered with generous vertical spacing.
 * Footer pinned at bottom for cross-template consistency.
 */
export function CenteredStackLayout({ data, fontPreset, logoEnabled = true, logoUrl = null, logoSize = null, logoIsDark = false, pc }) {
  return (
    <div className="absolute inset-0 flex flex-col items-center">
      {/* Logo at top */}
      {logoEnabled && (
        <NudgeableGroup groupId="logo" className="pt-[72px]">
          <SlideLogo className="h-16 w-16" style={{ color: pc.text(0.60) }} logoUrl={logoUrl} size={logoSize} isDark={logoIsDark} />
        </NudgeableGroup>
      )}

      <div className="flex-1 min-h-[40px]" />

      {/* Centered content */}
      <NudgeableGroup groupId="content" className="w-[80%] text-center">
        <SlideContent
          data={data}
          fontPreset={fontPreset}
          pc={pc}
          options={{
            showFooter: false,
            titleClass: 'text-center',
            bodyClass: 'text-center',
            mutedOpacity: 0.65,
            subtleOpacity: 0.45,
          }}
        />
      </NudgeableGroup>

      <div className="flex-1 min-h-[40px]" />

      {/* Footer — pinned at bottom */}
      <div className="absolute bottom-[64px] left-[64px] right-[64px]">
        <SlideFooter data={data} pc={pc} />
      </div>
    </div>
  );
}
